import React from 'react';
import './Toaster.css';
import { Alert, Snackbar } from '@mui/material';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { ToasterState, toasterStore } from '../stores';

export const Toaster = () => {
  const toaster: ToasterState = useRecoilValue(toasterStore);
  const setToaster: CallableFunction = useSetRecoilState(toasterStore);

  const handleClose = () => {
    setToaster({ isOpen: false, message: '', severity: 'success' });
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={toaster.isOpen}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={toaster.severity}
        sx={{ width: '100%' }}
      >
        {toaster.message}
      </Alert>
    </Snackbar>
  );
};
